import { useState } from "react";
import Box from "@mui/material/Box";
import SoftBox from "components/SoftBox";
import SlugTabs from "cxfcomponents/SlugTabs";
import Private from "./Private";
import Shared from "./Shared";

const FlowConfiguration = ({ currentSavedFlow, allowEditWorkflow }) => {
   const [configurationTab, setConfigurationTab] = useState("private");

   return (
      <Box sx={{ display: "flex", flex: 1, flexDirection: "column", minHeight: 0 }}>
         <SoftBox sx={{ position: "sticky", top: 0, zIndex: 2, alignSelf: "flex-start", flexShrink: 0 }}>
            <SlugTabs tabs={["private", "shared"]} value={configurationTab} onChange={setConfigurationTab} align="left" />
         </SoftBox>
         {configurationTab === "private" && <Private currentSavedFlow={currentSavedFlow} allowEditWorkflow={allowEditWorkflow} />}
         {configurationTab === "shared" && <Shared currentSavedFlow={currentSavedFlow} allowEditWorkflow={allowEditWorkflow} />}
      </Box>
   );
};

export default FlowConfiguration;
